import { z } from "zod";

import { RedirectDtoSchema } from "../../../dtos/redirects";
import { PutRedirectRequestBodySchema } from "../put-redirect";

export const BulkPutRedirectRequestBodySchema = z.object({
  experimentId: z.string().uuid().nullish(),
  redirects: PutRedirectRequestBodySchema.array(),
});

export type BulkPutRedirectRequestBodyType = z.infer<
  typeof BulkPutRedirectRequestBodySchema
>;

export const BulkPutRedirectResponseBodySchema = z.object({
  redirects: RedirectDtoSchema.array(),
});

export type BulkPutRedirectResponseBodyType = z.infer<
  typeof BulkPutRedirectResponseBodySchema
>;
